import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

/** Platform owner: two-step verification on the owner sign-in. */
export function PlatformSecurityCard() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/platform/security").then((r) => setS(r.data)).catch(() => {}); }, []);

  const toggle = async () => {
    const next = !s.require_otp;
    setBusy(true);
    try {
      const { data } = await api.put("/platform/security", { require_otp: next });
      setS(data);
      toast.success(next ? "Two-step verification is on for your owner account" : "Two-step verification turned off");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (!s) return null;
  return (
    <section className="mb-8 flex flex-wrap items-center justify-between gap-4 rounded-xl border border-slate-200 bg-white p-5" data-testid="platform-security-card">
      <div className="flex items-start gap-3">
        <span className={`rounded-lg p-2 ${s.require_otp ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}><ShieldCheck className="h-4 w-4" /></span>
        <div>
          <h2 className="font-display text-base font-semibold text-slate-900">Two-step verification (owner account)</h2>
          <p className="text-xs text-slate-500">
            {s.require_otp
              ? `Signing in as ${s.email} sends a 6-digit code to that inbox. You can trust a device for 30 days at sign-in.`
              : "Your owner account signs in with a password only. Turn this on to require an emailed code."}
          </p>
        </div>
      </div>
      <button type="button" role="switch" aria-checked={!!s.require_otp} disabled={busy} onClick={toggle}
              data-testid="platform-mfa-toggle"
              className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-60 ${s.require_otp ? "bg-emerald-600" : "bg-slate-300"}`}>
        <span className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${s.require_otp ? "translate-x-5" : "translate-x-0.5"}`} />
      </button>
    </section>
  );
}
